'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$() {
  this.aO3 = null;
  this.aO4 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$.prototype = $p;
$p.aA = (function() {
  if ((!this.aO4)) {
    this.aO3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aO4 = true;
  }
  return this.aO3;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$, "app.data.data_point_types$package$PaymentTerms$", ({
  Gc: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PaymentTerms$ };
//# sourceMappingURL=app.data.data_point_types$package$-Payment-Terms$.js.map
